import { ApplicationDataBaseField } from './ApplicationDataBaseField';
import { Controller } from 'react-hook-form';
import { NumericInput } from '@blueprintjs/core';
import { ApplicationDataFieldCommonProps } from './types';
import { ApplicationDataFormFieldPath } from '../ApplicationDataForm/ApplicationDataFormSchema';

function defaultFormatter(value: unknown) {
  return value ? String(value) : '-';
}

export interface ApplicationDataNumberFieldProps
  extends ApplicationDataFieldCommonProps {
  name: ApplicationDataFormFieldPath;
  formatter?: (value: unknown) => string;
  /**
   * Used to update other fields when this field updates
   */
  onChangeSideEffect?: (value: number) => void;
}

export const ApplicationDataNumberField: React.FC<
  ApplicationDataNumberFieldProps
> = ({ formatter = defaultFormatter, name, onChangeSideEffect, ...props }) => (
  <Controller
    name={name}
    render={({ field, fieldState }) => (
      <ApplicationDataBaseField
        errorMessage={
          fieldState.invalid ? fieldState.error?.message : undefined
        }
        valueElement={formatter(field.value as never)}
        inputElement={
          <NumericInput
            name={field.name}
            onValueChange={(valueAsNumber) => {
              field.onChange(valueAsNumber);
              if (onChangeSideEffect) onChangeSideEffect(valueAsNumber);
            }}
            onBlur={field.onBlur}
            value={field.value ?? null}
            allowNumericCharactersOnly={true}
            inputRef={field.ref}
            fill
            buttonPosition="none"
          />
        }
        {...props}
      />
    )}
  />
);
